/* istanbul ignore file */

export const REVIEWED_ON = 'Reviewed on';
export const NO_REVIEWS = 'Sorry, there are no reviews for this product yet.';
export const ERROR_REVIEWS = 'Sorry, there has been an error getting the reviews';

export const PAGINATION_PREVIOUS_PAGE = 'Previous page';
export const PAGINATION_NEXT_PAGE = 'Next page';
export const HIDE_TEXT_ON_LINE = 3;
